'use client';
'use strict';

var client = require('@apollo/client');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var FORMIE_FORM_FRAGMENT = require('../gql/fragments/FORMIE_FORM_FRAGMENT.js');
var FORMIE_FORM_QUERY = require('../gql/queries/FORMIE_FORM_QUERY.js');

/**
 * Custom hook for querying form data using FormieFormQuery.
 *
 * @param props - The variables for the FormieFormQuery.
 * @returns An object containing the form data, loading state, and error state.
 */ function useFormieQuery(props) {
    const { data, loading, error } = client.useQuery(FORMIE_FORM_QUERY.FORMIE_FORM_QUERY, {
        variables: props
    });
    const form = generatedCraftcms.getFragmentData(FORMIE_FORM_FRAGMENT.FORMIE_FORM_FRAGMENT, data == null ? void 0 : data.formieForm);
    return {
        form,
        loading,
        error
    };
}

module.exports = useFormieQuery;
